import type { IconData } from '@stacksjs/iconify-core'

export const handLittleFinger: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M26.67 3.055h1.52v19.81h-1.52Zm-1.52 22.85H9.91v-1.52H8.38v1.52H6.86v4.57h21.33v-4.57h-1.52v-3.04h-1.52Zm0 3.05H22.1v-1.52h3.05Zm-1.53-27.43h3.05v1.53h-3.05Zm-4.57 15.24h3.05v1.52h-3.05Zm-7.62 1.52H16v1.53h-4.57Z\"/><path fill=\"currentColor\" d=\"M12.95 12.195h-1.52v1.52h3.05v-4.57h3.05v4.57h-3.05v1.53H16v3.04h1.53v-1.52h1.52v-7.62h3.05v7.62h1.52V3.055H22.1v4.57H9.91v1.52h3.04zm-3.04 4.57h1.52v1.52H9.91Z\"/><path fill=\"currentColor\" d=\"M11.43 12.195v-1.53H9.91v-1.52H8.38v1.52H6.86v1.53zm-4.57 10.67h1.52v1.52H6.86Zm-1.52-3.05h1.52v3.05H5.34Zm0-7.62h1.52v1.52H5.34Zm-1.53 1.52h1.53v6.1H3.81Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default handLittleFinger
